import { t } from 'i18next';
import React from 'react';
import { useCountdown } from './useCountdown';

const CountdownTimer = ({ targetDate }) => {
    const [days, hours, minutes, seconds] = useCountdown(targetDate);

    if (days + hours + minutes + seconds <= 0) {
        return <ExpiredNotice />;
    } else {
        return (
            <ShowCounter
                days={days}
                hours={hours}
                minutes={minutes}
                seconds={seconds}
            />
        );
    }
};

const ExpiredNotice = () => {
    return (
        <div className="expired-notice">
            <span>הזמן הסתיים</span>
            <p>נא לבחור מוצר חדש</p>
        </div>
    );
};
const ShowCounter = ({ days, hours, minutes, seconds }) => {
    return (
        <div className="show-counter">
            <DateTimeDisplay value={minutes} type={t("Mins")} isDanger={minutes < 1} />
            <p>:</p>
            <DateTimeDisplay value={seconds} type={t("Seconds")} isDanger={minutes < 1} />
        </div>
    );
};

const DateTimeDisplay = ({ value, type, isDanger }) => {
    return (
        <div className={isDanger ? 'countdown danger' : 'countdown'}>
            <p>{value}</p>
            <span>{type}</span>
        </div>
    );
};

export default CountdownTimer;